






































import Vue from 'vue'
import { mapState } from 'vuex'
import SourceFilter from '@/components/source-filter.vue'

export default Vue.extend({
  components: {
    SourceFilter,
  },
  data: () => ({
    selected: [],
    sortColumn: '',
    sortDescending: false,
    headers: [
      {
        text: 'Источник',
        align: 'start',
        value: 'name',
      },
      {
        text: 'URL',
        value: 'url',
      },
      {
        text: 'Новостей',
        align: 'center',
        value: 'news_count',
      },
      {
        text: 'Парсеров',
        align: 'start',
        value: 'spider_count',
      },
    ],
  }),
  computed: mapState({
    filter: (state: any) => state.sources.filter,
    loading: (state: any) => state.sources.loading,
    items: (state: any) => state.sources.items,
    itemsCount: (state: any) => state.sources.itemsCount,
    page: (state: any) => state.sources.page,
    pages: (state: any) => state.sources.pages,
  }),
  created() {
    this.$store.commit('sources/CLEAR_STATE')
    this.fetch()
  },
  methods: {
    fetch() {
      this.$store.dispatch('sources/FETCH')
    },
    onSourceClick(value) {
      this.$emit('select', value)
    },
    onPageChange(page: number) {
      this.$store.commit('sources/SET_PAGE', page)
      this.fetch()
    },
    onSortChange() {
      this.$store.commit(
        'sources/SET_ORDERING',
        this.sortDescending ? '-' + this.sortColumn : this.sortColumn,
      )
      this.fetch()
    },
    onFilterChange(filter: any) {
      this.$store.commit('sources/SET_PAGE', 1)
      this.$store.commit('sources/SET_FILTER', filter)
      this.fetch()
    },
  },
})
